'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import useControlled from '@mui/utils/useControlled';
export default function usePagination() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    // keep default values in sync with @default tags in Pagination.propTypes
    var _props_boundaryCount = props.boundaryCount, boundaryCount = _props_boundaryCount === void 0 ? 1 : _props_boundaryCount, _props_componentName = props.componentName, componentName = _props_componentName === void 0 ? 'usePagination' : _props_componentName, _props_count = props.count, count = _props_count === void 0 ? 1 : _props_count, _props_defaultPage = props.defaultPage, defaultPage = _props_defaultPage === void 0 ? 1 : _props_defaultPage, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_hideNextButton = props.hideNextButton, hideNextButton = _props_hideNextButton === void 0 ? false : _props_hideNextButton, _props_hidePrevButton = props.hidePrevButton, hidePrevButton = _props_hidePrevButton === void 0 ? false : _props_hidePrevButton, handleChange = props.onChange, pageProp = props.page, _props_showFirstButton = props.showFirstButton, showFirstButton = _props_showFirstButton === void 0 ? false : _props_showFirstButton, _props_showLastButton = props.showLastButton, showLastButton = _props_showLastButton === void 0 ? false : _props_showLastButton, _props_siblingCount = props.siblingCount, siblingCount = _props_siblingCount === void 0 ? 1 : _props_siblingCount, other = _object_without_properties(props, [
        "boundaryCount",
        "componentName",
        "count",
        "defaultPage",
        "disabled",
        "hideNextButton",
        "hidePrevButton",
        "onChange",
        "page",
        "showFirstButton",
        "showLastButton",
        "siblingCount"
    ]);
    var _useControlled = _sliced_to_array(useControlled({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: 'page'
    }), 2), page = _useControlled[0], setPageState = _useControlled[1];
    var handleClick = function(event, value) {
        if (!pageProp) {
            setPageState(value);
        }
        if (handleChange) {
            handleChange(event, value);
        }
    };
    // https://dev.to/namirsab/comment/2050
    var range = function(start, end) {
        var length = end - start + 1;
        return Array.from({
            length: length
        }, function(_, i) {
            return start + i;
        });
    };
    var startPages = range(1, Math.min(boundaryCount, count));
    var endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    var siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    var siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    count - boundaryCount - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    var itemList = _to_consumable_array(showFirstButton ? [
        'first'
    ] : []).concat(_to_consumable_array(hidePrevButton ? [] : [
        'previous'
    ]), _to_consumable_array(startPages), // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    _to_consumable_array(siblingsStart > boundaryCount + 2 ? [
        'start-ellipsis'
    ] : boundaryCount + 1 < count - boundaryCount ? [
        boundaryCount + 1
    ] : []), // Sibling pages
    _to_consumable_array(range(siblingsStart, siblingsEnd)), // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    _to_consumable_array(siblingsEnd < count - boundaryCount - 1 ? [
        'end-ellipsis'
    ] : count - boundaryCount > boundaryCount ? [
        count - boundaryCount
    ] : []), _to_consumable_array(endPages), _to_consumable_array(hideNextButton ? [] : [
        'next'
    ]), _to_consumable_array(showLastButton ? [
        'last'
    ] : []));
    // Map the button type to its page number
    var buttonPage = function(type) {
        switch(type){
            case 'first':
                return 1;
            case 'previous':
                return page - 1;
            case 'next':
                return page + 1;
            case 'last':
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    var items = itemList.map(function(item) {
        return typeof item === 'number' ? {
            onClick: function(event) {
                handleClick(event, item);
            },
            type: 'page',
            page: item,
            selected: item === page,
            disabled: disabled,
            'aria-current': item === page ? 'page' : undefined
        } : {
            onClick: function(event) {
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || !item.includes('ellipsis') && (item === 'next' || item === 'last' ? page >= count : page <= 1)
        };
    });
    return _object_spread({
        items: items
    }, other);
}
